$(document).ready(function(){

	
	/*\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/*/
	/*					POUR LES LIENS DE PARTAGE				*/
	/*\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/*/
	open_popup = function(url){

		mywidth = 500;
		myheight = 350;
		myleft = (screen.width - mywidth) / 2;
		mytop = (screen.height - myheight) / 2;
		window.open( url, 'nouvo', 'width='+mywidth+',height='+myheight+',scrollbars=1,resizable=0,menubar=0,toolbar=0,status=0,location=0,directories=0,left='+myleft+',top='+mytop);
	}



});

